import * as React from 'react';
import { SVGProps } from 'react';

const IconPolygonPurpleSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3 11H2c0-1.575.363-3.125 1.044-4.463l.915.408C3.34 8.141 3 9.55 3 11ZM11 2v1c-1.481 0-2.88.326-4.066.944l-.415-.912C7.852 2.35 9.398 2 11 2Z"
      fill="#9CA3FF"
    />
    <path
      d="M4 13.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM15 2.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM6 4.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
      fill="var(--color-typo-primary)"
    />
  </svg>
);
export default IconPolygonPurpleSizeS;
